import { Group, Home, ModeNight, Settings } from '@mui/icons-material'
import {
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Switch,
    Collapse,
    Badge,
    styled,
} from '@mui/material'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import InventoryIcon from '@mui/icons-material/Inventory'
import CreditScoreIcon from '@mui/icons-material/CreditScore'
import { useDispatch, useSelector } from 'react-redux'
import RecentActorsIcon from '@mui/icons-material/RecentActors'
import LocalMallIcon from '@mui/icons-material/LocalMall'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import ListAltIcon from '@mui/icons-material/ListAlt'
import SensorDoorIcon from '@mui/icons-material/SensorDoor'
import WarehouseIcon from '@mui/icons-material/Warehouse'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import DirectionsBoatFilledIcon from '@mui/icons-material/DirectionsBoatFilled'
import InvertColorsIcon from '@mui/icons-material/InvertColors'
import CategoryIcon from '@mui/icons-material/Category'
import SmsFailedIcon from '@mui/icons-material/SmsFailed'
import PaidIcon from '@mui/icons-material/Paid'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import BarChartIcon from '@mui/icons-material/BarChart'
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel'
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn'
import SortIcon from '@mui/icons-material/Sort'
import {
    settingOpenAction,
    updateSideBarSelected,
    userOpenAction,
} from '../store/actions/modeAction'
import { getRoleList } from '../store/actions/usersAction'
import FactoryIcon from '@mui/icons-material/Factory'
import EventNoteIcon from '@mui/icons-material/EventNote'
import { roleListId, roleType } from '../config/roleList'
import { checkUserRole } from '../common/checkUserRole'
import { getNewOrderCount } from '../store/actions/orderAction'

const CLIENT = process.env.REACT_APP_CLIENT || 'woodworth'

const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
    '&.Mui-selected': {
        backgroundColor: CLIENT === 'woodworth' ? '#1976d2' : '#2e7d32',
        color: '#FFFFFF',
    },
    '&:hover': {
        backgroundColor: CLIENT === 'woodworth' ? '#1976d2' : '#2e7d32',
        color: '#FFFFFF',
    },
}))

const Sidebar = ({ mode, setMode, userInfo }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getRoleList())
        dispatch(getNewOrderCount())
    }, [dispatch])
    const { userOpen, settingOpen, selected } = useSelector(
        (state) => state.mode
    )
    const userState = useSelector((state) => state.user)
    const { newOrderCount } = useSelector((state) => state.order)
    const { roleList } = userState
    return (
        <Box flex={1} p={2} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Box
                position="fixed"
                maxHeight="100vh"
                overflow="auto"
                style={{ paddingBottom: '100px' }}
            >
                <List>
                    <ListItem disablePadding>
                        <CustomListItemButton
                            selected={selected === 0}
                            onClick={() => dispatch(updateSideBarSelected(0))}
                            component={Link}
                            to="/"
                        >
                            <ListItemIcon>
                                <Home />
                            </ListItemIcon>
                            <ListItemText primary="Homepage" />
                        </CustomListItemButton>
                    </ListItem>
                    {/* <ListItem disablePadding>
                        <ListItemButton component={Link} to="/roles">
                            <ListItemIcon>
                                <Article />
                            </ListItemIcon>
                            <ListItemText primary="Roles" />
                        </ListItemButton>
                    </ListItem> */}
                    <CustomListItemButton
                        selected={selected === 1}
                        onClick={() => {
                            dispatch(userOpenAction(userOpen))
                            dispatch(updateSideBarSelected(1))
                        }}
                    >
                        <ListItemIcon>
                            <Group />
                        </ListItemIcon>
                        <ListItemText primary="Users" />
                        {userOpen ? <ExpandLess /> : <ExpandMore />}
                    </CustomListItemButton>
                    <Collapse in={userOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.USER,
                                roleType.READ
                            ) && (
                                <CustomListItemButton
                                    selected={selected === 2}
                                    onClick={() =>
                                        dispatch(updateSideBarSelected(2))
                                    }
                                    sx={{ pl: 4 }}
                                    component={Link}
                                    to="/users"
                                >
                                    <ListItemIcon>
                                        <RecentActorsIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="All Users" />
                                </CustomListItemButton>
                            )}
                            {checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.USER,
                                roleType.CREATE
                            ) && (
                                <CustomListItemButton
                                    selected={selected === 3}
                                    onClick={() =>
                                        dispatch(updateSideBarSelected(3))
                                    }
                                    sx={{ pl: 4 }}
                                    component={Link}
                                    to="/addnewuser"
                                >
                                    <ListItemIcon>
                                        <GroupAddIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Add New User" />
                                </CustomListItemButton>
                            )}
                        </List>
                    </Collapse>
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.CUSTOMER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 4}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(4))
                                }
                                component={Link}
                                to="/customers"
                            >
                                <ListItemIcon>
                                    <LocalMallIcon />
                                </ListItemIcon>
                                <ListItemText primary="Dealers" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.STORE_CREDIT,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 28}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(28))
                                }
                                component={Link}
                                to="/store-credits"
                            >
                                <ListItemIcon>
                                    <CreditScoreIcon />
                                </ListItemIcon>
                                <ListItemText primary="Store Credit" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ORDER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 5}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(5))
                                }
                                component={Link}
                                to="/orders"
                            >
                                <ListItemIcon>
                                    <Badge
                                        badgeContent={newOrderCount || 0}
                                        color="error"
                                    >
                                        <ListAltIcon />
                                    </Badge>
                                </ListItemIcon>
                                <ListItemText primary="Orders" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ORDER_PAYMENT,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 6}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(6))
                                }
                                component={Link}
                                to="/orderpayments"
                            >
                                <ListItemIcon>
                                    <PaidIcon />
                                </ListItemIcon>
                                <ListItemText primary="Order Payments" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ORDER_SHIPMENT,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 7}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(7))
                                }
                                component={Link}
                                to="/ordershipments"
                            >
                                <ListItemIcon>
                                    <LocalShippingIcon />
                                </ListItemIcon>
                                <ListItemText primary="Order Shipments" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.RETURN_ORDER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 8}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(8))
                                }
                                component={Link}
                                to="/returnorders"
                            >
                                <ListItemIcon>
                                    <AssignmentReturnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Return Order" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.SUPPLIER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 9}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(9))
                                }
                                component={Link}
                                to="/suppliers"
                            >
                                <ListItemIcon>
                                    <FactoryIcon />
                                </ListItemIcon>
                                <ListItemText primary="Supplier" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.PURCHASE_ORDER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 10}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(10))
                                }
                                component={Link}
                                to="/purchaseorders"
                            >
                                <ListItemIcon>
                                    <ShoppingCartIcon />
                                </ListItemIcon>
                                <ListItemText primary="Purchase Order" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.SHIPMENT,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 11}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(11))
                                }
                                component={Link}
                                to="/shipments"
                            >
                                <ListItemIcon>
                                    <DirectionsBoatFilledIcon />
                                </ListItemIcon>
                                <ListItemText primary="Shipment" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ITEM,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 12}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(12))
                                }
                                component={Link}
                                to="/items"
                            >
                                <ListItemIcon>
                                    <EventNoteIcon />
                                </ListItemIcon>
                                <ListItemText primary="Item" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ITEM_ANALYTICS,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 13}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(13))
                                }
                                component={Link}
                                to="/itemanalytics"
                            >
                                <ListItemIcon>
                                    <BarChartIcon />
                                </ListItemIcon>
                                <ListItemText primary="Item Analytics" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.ITEM_ANALYTICS,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 14}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(14))
                                }
                                component={Link}
                                to="/orderanalytics"
                            >
                                <ListItemIcon>
                                    <QueryStatsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Order Analytics" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.DEFECTIVE_ITEM,
                        roleType.READ
                    ) && (
                        <>
                            <ListItem disablePadding>
                                <CustomListItemButton
                                    selected={selected === 27}
                                    onClick={() =>
                                        dispatch(updateSideBarSelected(27))
                                    }
                                    component={Link}
                                    to="/defective-groups"
                                >
                                    <ListItemIcon>
                                        <SmsFailedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Defective Group" />
                                </CustomListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <CustomListItemButton
                                    selected={selected === 15}
                                    onClick={() =>
                                        dispatch(updateSideBarSelected(15))
                                    }
                                    component={Link}
                                    to="/defectiveitems"
                                >
                                    <ListItemIcon>
                                        <SmsFailedIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Defective Item" />
                                </CustomListItemButton>
                            </ListItem>
                        </>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.PRODUCT,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 16}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(16))
                                }
                                component={Link}
                                to="/products"
                            >
                                <ListItemIcon>
                                    <InventoryIcon />
                                </ListItemIcon>
                                <ListItemText primary="Product" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.PRODUCT_COLOR,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 17}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(17))
                                }
                                component={Link}
                                to="/productcolors"
                            >
                                <ListItemIcon>
                                    <InvertColorsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Product Colors" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.LOG,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 18}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(18))
                                }
                                component={Link}
                                to="/logs"
                            >
                                <ListItemIcon>
                                    <ManageSearchIcon />
                                </ListItemIcon>
                                <ListItemText primary="Logs" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.WAREHOUSE,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 19}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(19))
                                }
                                component={Link}
                                to="/warehouses"
                            >
                                <ListItemIcon>
                                    <WarehouseIcon />
                                </ListItemIcon>
                                <ListItemText primary="Warehouses" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.BANNER,
                        roleType.READ
                    ) && (
                        <ListItem disablePadding>
                            <CustomListItemButton
                                selected={selected === 20}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(20))
                                }
                                component={Link}
                                to="/banners"
                            >
                                <ListItemIcon>
                                    <ViewCarouselIcon />
                                </ListItemIcon>
                                <ListItemText primary="Banner" />
                            </CustomListItemButton>
                        </ListItem>
                    )}
                    <CustomListItemButton
                        selected={selected === 21}
                        onClick={() => {
                            dispatch(updateSideBarSelected(21))
                            dispatch(settingOpenAction(settingOpen))
                        }}
                    >
                        <ListItemIcon>
                            <Settings />
                        </ListItemIcon>
                        <ListItemText primary="Settings" />
                        {settingOpen ? <ExpandLess /> : <ExpandMore />}
                    </CustomListItemButton>
                    <Collapse in={settingOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <CustomListItemButton
                                selected={selected === 22}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(22))
                                }
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/productcategory"
                            >
                                <ListItemIcon>
                                    <CategoryIcon />
                                </ListItemIcon>
                                <ListItemText primary="Product Category" />
                            </CustomListItemButton>
                            <CustomListItemButton
                                selected={selected === 23}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(23))
                                }
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/itemcategory"
                            >
                                <ListItemIcon>
                                    <SortIcon />
                                </ListItemIcon>
                                <ListItemText primary="Item Category" />
                            </CustomListItemButton>
                            <CustomListItemButton
                                selected={selected === 24}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(24))
                                }
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/doorcategory"
                            >
                                <ListItemIcon>
                                    <SensorDoorIcon />
                                </ListItemIcon>
                                <ListItemText primary="Door Category" />
                            </CustomListItemButton>
                            <CustomListItemButton
                                selected={selected === 25}
                                onClick={() =>
                                    dispatch(updateSideBarSelected(25))
                                }
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/basetaxes"
                            >
                                <ListItemIcon>
                                    <RequestQuoteIcon />
                                </ListItemIcon>
                                <ListItemText primary="Base Tax" />
                            </CustomListItemButton>

                            {checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.ITEM,
                                roleType.APPROVAL
                            ) && (
                                <CustomListItemButton
                                    selected={selected === 26}
                                    onClick={() =>
                                        dispatch(updateSideBarSelected(26))
                                    }
                                    sx={{ pl: 4 }}
                                    component={Link}
                                    to="/itemrecords"
                                >
                                    <ListItemIcon>
                                        <RequestQuoteIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Item Change Price" />
                                </CustomListItemButton>
                            )}
                            {/* <ListItemButton
                                sx={{ pl: 4 }}
                                component={Link}
                                to="/addnewuser"
                            >
                                <ListItemIcon>
                                    <GroupAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="Add New User" />
                            </ListItemButton> */}
                        </List>
                    </Collapse>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <ModeNight />
                            </ListItemIcon>
                            <Switch
                                checked={mode === 'dark'}
                                value={mode}
                                onClick={() =>
                                    setMode(mode === 'light' ? 'dark' : 'light')
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </Box>
    )
}

export default Sidebar
